import { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const logo = require("../../assets/logo.png");
const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [validCredentials, setValidCredentials] = useState(true);
  const handleLogin = async (e) => {
    e.preventDefault();
    const user = { email, password };
    var url;
    if(email === "admin@elbidet.com"){
      url = "https://uplbidet-api.vercel.app/api/admin/login";
    }else{
      url = "https://uplbidet-api.vercel.app/api/users/login";
    }
    const res = await axios.post(
      url,
      user,
      {
        withCredentials: true,
      }
    );
    console.log(res);
    const { success } = res.data;
    if (success) {
      setValidCredentials(true);
      window.location.href = "/";
    } else {
      setValidCredentials(false);
    }
  };

  return (
    <div className="Login">
      <div className="login-image-div">
        <img
          src={require("../../assets/1920px-UPLBDevCom-4 1.png")}
          alt="man in campus"
        ></img>
      </div>
      <div className="login-form-div">
        <img src={logo} alt="logo"></img>
        <form className="login-card">
          <input
            required
            type="email"
            placeholder="Enter email here..."
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          ></input>
          <label>EMAIL</label>
          <input
            required
            type="password"
            placeholder="Enter password here..."
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          ></input>
          <div className="password-div">
            <label>PASSWORD</label>
            <a
              href="https://www.youtube.com/watch?v=dQw4w9WgXcQ"
              target="_blank"
              rel="noreferrer"
            >
              FORGOT PASSWORD?
            </a>
          </div>
          <div className="buttons">
            <button className="login" onClick={handleLogin}>
              LOGIN
            </button>
            <button className="signup">
              <Link to="/signup">SIGNUP</Link>
            </button>
          </div>
          {!validCredentials && (
            <div className="error-div">
              <p className="error">Incorrect email or password!</p>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default Login;
